import { VoiceCaptureButton } from '@focuslee/shared-mini-app';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RitualConfig } from '../../helpers/ritual';
import { i18next } from '../../i18n';

interface JournalVoiceButtonProps {
  onTranscript: (text: string) => void;
  config: RitualConfig | null;
}

export const JournalVoiceButton: FC<JournalVoiceButtonProps> = ({ onTranscript, config }) => {
  const { t } = useTranslation();

  return (
    <VoiceCaptureButton
      onTranscript={onTranscript}
      getLanguage={() => i18next.language}
      labels={{
        processing: t('journal.processing'),
        stopRecording: t('journal.stopRecording'),
        tapToSpeak: t('journal.tapToSpeak'),
      }}
      buttonColor={config?.buttonBgEnabled}
      buttonTextColor={config?.buttonText}
    />
  );
};
